import { View, Text, Image, TouchableOpacity } from "react-native";
import React from "react";

import { AntDesign, FontAwesome } from "@expo/vector-icons";

import QA from "../../assets/svg/QA";
import translate from "../../functions/translate";
import { supportIcon } from "../../imports";
import MyText from "../custom/MyText";
import { white } from "../../colors";
import { useNavigation } from "@react-navigation/native";
import { useSelector } from "react-redux";
import { Toast } from "react-native-toast-message/lib/src/Toast";

export default function UserHelper() {
  const navigation = useNavigation();
  const main = useSelector((store) => store.main);
  return (
    <View style={{ width: "94%" }}>
      <View style={{ width: "100%", flexDirection: "row", marginVertical: 15 }}>
        <TouchableOpacity
          onPress={() => navigation.navigate("ChatSettings")}
          style={{
            flex: 1,
            height: 150,
            backgroundColor: "#a67bc9",
            borderRadius: 10,
            padding: 10,
            alignItems: "center",
          }}
        >
          <MyText
            style={{
              textAlign: "center",
              fontSize: 22,
              color: white,
            }}
          >
            {"تنظیمات چت"}
          </MyText>
          <View style={{ flex: 1 }}></View>
          <View style={{ alignItems: "flex-end", width: "100%" }}>
            <QA />
          </View>
        </TouchableOpacity>
        <View style={{ width: 15 }}></View>
        <TouchableOpacity
          onPress={() => navigation.navigate("NewTutorial")}
          style={{
            flex: 1,
            height: 150,
            backgroundColor: "#feb94e",
            borderRadius: 10,
            padding: 10,
            paddingBottom: 0,
            alignItems: "center",
          }}
        >
          <MyText
            style={{
              textAlign: "center",
              fontSize: 21,
              color: white,
            }}
          >
            {'آموزش های من'}
          </MyText>
          <View style={{ flex: 1 }}></View>
          <View style={{ alignItems: "flex-end", width: "100%" }}>
            <FontAwesome name="universal-access" size={60} color="#fefefe" />
          </View>
          <View style={{ height: 10 }}></View>
        </TouchableOpacity>
      </View>
      <View style={{ width: "100%", flexDirection: "row", marginVertical: 15 }}>
        <TouchableOpacity
          onPress={() => navigation.navigate("SupportTime")}
          style={{
            flex: 1,
            height: 150,
            backgroundColor: "#ab3838",
            borderRadius: 10,
            padding: 10,
            alignItems: "center",
          }}
        >
          <MyText
            style={{
              textAlign: "center",
              fontSize: 18,
              color: white,
            }}
          >
            {translate("support time")}
          </MyText>
          <View style={{ flex: 1 }}></View>
          <View style={{ alignItems: "flex-end", width: "100%" }}>
            <AntDesign name="clockcircleo" size={55} color="#fff" />
          </View>
        </TouchableOpacity>
        <View style={{ width: 15 }}></View>
        <TouchableOpacity
          onPress={() => navigation.navigate("Notifications")}
          style={{
            flex: 1,
            height: 150,
            backgroundColor: "#3e7b7a",
            borderRadius: 10,
            padding: 10,
            paddingBottom: 0,
            alignItems: "center",
          }}
        >
          <MyText
            style={{
              textAlign: "center",
              fontSize: 22,
              color: white,
            }}
          >
            {"اعلانات"}
          </MyText>
          <View style={{ flex: 1, marginBottom: -10 }}></View>
          <View
            style={{ alignItems: "flex-end", width: "100%", marginTop: -10 }}
          >
            <FontAwesome name="bell-o" size={55} style={{}} color="#efefef" />
          </View>
          <View style={{ height: 10 }}></View>
        </TouchableOpacity>
      </View>
    </View>
  );
}
